<template>
  <section>
    <!-- 弹窗1 -->
    <saas-alert
      :visible="popAlertCheckVisible"
      :confirm="true"
      :title="$t('host.k_533001')"
      :confirmText="$t('host.k_533002')"
      :cancelText="$t('host.k_533003')"
      :isShowClose="true"
      @onClose="popAlertCheckClose"
      @onSubmit="popAlertCheckSubmit"
      @onCancel="popAlertCheckClose"
    >
      <div slot="content">
        <span>{{ $t('host.k_533004') }}</span>
        <p
          v-if="!deviceInfo.device_detail.video || !deviceInfo.device_detail.audio"
          class="error_tips"
        >
          <template
            v-if="
              !deviceInfo.device_detail.video && deviceInfo.device_detail.audio && webinarMode != 1
            "
          >
            {{ $t('host.k_533005') }}
          </template>
          <!-- prettier-ignore -->
          <template v-else-if="!deviceInfo.device_detail.audio">
          {{$t('host.k_533010',{
            a:!deviceInfo.device_detail.video ? $t('host.k_533006') : $t('host.k_533007') ,
            b:roleName == 4 && webinarMode == 3 ? $t('host.k_533008') : $t('host.k_533009') 
          })}}</template>
        </p>
      </div>
    </saas-alert>

    <!-- 弹窗2 -->
    <saas-alert
      :visible="popAlertCheckConfirmVisible"
      :confirm="true"
      :confirmText="$t('host.k_533002')"
      :cancelText="$t('host.k_533011')"
      @onClose="popAlertCheckConfirm"
      @onCancel="popAlertCheckConfirm"
      @onSubmit="popAlertCheckConfirmClose"
    >
      <div slot="content">
        <span>{{ $t('host.k_533012') }}</span>
      </div>
    </saas-alert>
    <!-- 弹窗3 -->
    <vh-dialog
      :title="agreementInfo.title"
      :visible.sync="agreementVisible"
      width="520px"
      custom-class="live_agreement_dialog"
      :close-on-click-modal="false"
      :show-close="false"
      append-to-body
    >
      <div class="live_agreement_content" id="agreeContent">
        <!-- 内容 -->
        <div class="restriction-content" v-html="agreementInfo.content"></div>
        <!-- 声明协议 -->
        <div
          v-if="agreementInfo.statement_content"
          class="restriction-law"
          v-html="agreementInfo.statement_content"
        ></div>
      </div>
      <p class="agreement-tips">{{ $t('host.k_533013') }}</p>
      <div slot="footer">
        <div>
          <vh-button
            type="primary"
            round
            v-if="agreementInfo.agree_type == 2 && canSub != true"
            disabled
          >
            {{ $t('other.other_1017') }} &nbsp;{{ agreementInfo.agree_time }}s
          </vh-button>
          <vh-button v-else type="primary" round :disabled="!canSub" @click.stop="handleConfirm">
            {{ $t('other.other_1017') }}
          </vh-button>
        </div>
      </div>
    </vh-dialog>
  </section>
</template>

<script>
  import SaasAlert from '@/packages/pc-alert/src/alert.vue';
  import { replaceWithRules } from '@/app-shared/utils/tool.js';
  // import filterXSS from 'filterXSS';
  import { useRoomBaseServer } from 'middle-domain';
  export default {
    components: {
      SaasAlert
    },
    data() {
      return {
        agreementVisible: false,
        popAlertCheckVisible: false,
        popAlertCheckConfirmVisible: false,
        firstVisit: false, //浏览器首次加载强制检测
        agreementInfo: {},
        canSub: false
      };
    },
    computed: {
      //设备状态
      deviceInfo() {
        return this.$domainStore.state.mediaCheckServer.deviceInfo;
      },
      //1-音频直播、2-视频直播、3-互动直播 6-分组直播 5 定时直播
      webinarMode() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.mode;
      },
      // 角色
      roleName() {
        return this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name;
      }
    },
    created() {
      this.handleLiveAgreement();
    },
    methods: {
      /**
       * 判断，并检查默认是否展示
       */
      setDefaultAlertVisible() {
        const { watchInitData } = useRoomBaseServer().state;
        this.liveType = watchInitData?.webinar?.type;

        //用户角色
        const roleName = watchInitData.join_info.role_name;
        this.popAlertCheckVisible = true;
        // 助理不展示
        if (roleName == 3) {
          this.popAlertCheckVisible = false;
        }

        // 直播中
        if (this.liveType == 1) {
          this.popAlertCheckVisible = false;
        }
        this.firstVisit = localStorage.getItem('firstVisit') || '';
        // if (!this.firstVisit) {
        //   //浏览器首次加载强制检测
        //   localStorage.setItem('firstVisit', '1');
        // }
      },
      handleLiveAgreement() {
        const { watchInitData } = useRoomBaseServer().state;
        this.liveType = watchInitData?.webinar?.type;
        const data = watchInitData.live_agreement;
        const role = watchInitData.join_info.role_name;
        //嘉宾上麦后不弹协议，主持人开播后不弹协议
        if (
          ((role == 1 && this.liveType != 1) ||
            (role == 4 && !this.$domainStore.state.micServer.isSpeakOn)) &&
          data.is_open == 1 &&
          ((role == 1 && data.apply_roles.includes('host')) ||
            (role == 4 && data.apply_roles.includes('guest')))
        ) {
          let statement_content = '';
          if (data.statement_status && Array.isArray(data.statement_info)) {
            statement_content = data.statement_content;
            const rules = [];
            data.statement_info.forEach(statement => {
              const txtHtml = `<a target="_blank" class="law-link" href="${statement.link}">${statement.title}</a>`;
              rules.push({
                before: statement.title,
                after: txtHtml
              });
            });
            statement_content = replaceWithRules(statement_content, rules);
          }
          this.agreementInfo = {
            statement_content: statement_content,
            rule: data.rule,
            title: data.title,
            content: data.content,
            agree_time: data.agree_time,
            agree_type: data.agree_type
          };
          this.agreementVisible = true;
          this.$nextTick(() => {
            this.handleAgreeType(data);
          });
        } else {
          this.setDefaultAlertVisible();
        }
      },
      handleAgreeType(data) {
        if (this.agreementInfo.agree_type == 2) {
          this.intervalId && clearInterval(this.intervalId);
          this.intervalId = setInterval(() => {
            if (this.agreementInfo.agree_time === 0) {
              this.canSub = true;
              clearInterval(this.intervalId);
            }
            this.agreementInfo.agree_time--;
          }, 1000);
        } else if (this.agreementInfo.agree_type == 1) {
          this.$nextTick(() => {
            this.checkIfRead();
            document.getElementById('agreeContent').addEventListener('scroll', this.checkIfRead);
          });
        } else {
          this.canSub = true;
        }
      },
      checkIfRead() {
        const contentElement = document.getElementById('agreeContent');
        if (contentElement.scrollHeight <= contentElement.clientHeight) {
          this.canSub = true;
        } else {
          const isAtBottom =
            Math.abs(
              contentElement.scrollTop + contentElement.clientHeight - contentElement.scrollHeight
            ) < 5;
          if (isAtBottom) {
            this.canSub = true;
          }
        }
      },
      handleConfirm() {
        this.agreementVisible = false;
        this.setDefaultAlertVisible();
      },
      show() {
        this.popAlertCheckVisible = true;
      },
      popAlertCheckSubmit() {
        window.vhallReportForProduct?.report(110004); // 埋点:设备检测-立即检测
        this.popAlertCheckVisible = false;
        this.$emit('show');
      },
      async popAlertCheckClose() {
        window.vhallReportForProduct?.report(110005); // 埋点:设备检测-暂不检测
        this.popAlertCheckVisible = false;
        await this.$nextTick();
        this.$emit('closeTestEquDialog');
        // this.popAlertCheckConfirmVisible = true;
      },
      popAlertCheckConfirm() {
        this.popAlertCheckConfirmVisible = false;
      },
      popAlertCheckConfirmClose() {
        this.popAlertCheckConfirmVisible = false;
        this.$emit('show');
      }
    }
  };
</script>

<style lang="less" scoped>
  .error_tips {
    color: #fb3a32;
    font-size: 12px;
    margin-top: 5px;
  }
  .btnsbox {
    text-align: right;
    position: absolute;
    bottom: 24px;
    right: 32px;
    button {
      border: none;
      box-shadow: none;
      outline: none;
      display: inline-block;
      height: 36px;
      line-height: 36px;
      border-radius: 18px;
      display: inline-block;
      margin-bottom: 0;
      font-size: 14px;
      color: #666;
      font-weight: 400;
      text-align: center;
      padding: 0 24px;
      &.confirm {
        background: #fb3a32;
        color: #ffffff;
      }
      &.cancel {
        border: 1px solid #ccc;
        color: #666666;
        line-height: 34px;
        margin-left: 12px;
        &:hover {
          background: #fb3a32;
          border-color: #fb3a32;
          color: #ffffff;
        }
      }
    }
  }
</style>
<style lang="less">
  .live_agreement_dialog {
    .vh-dialog__header {
      padding: 24px 32px 12px;
    }
    .live_agreement_content {
      max-height: 304px;
      min-height: 24px;
      overflow: auto;
      word-break: break-word;
      box-sizing: border-box;
    }
    .restriction-law {
      color: rgb(140, 140, 140);
      line-height: 22px;
      margin-top: 8px;
    }
    .agreement-tips {
      padding-top: 12px;
      line-height: 14px;
      font-size: 14px;
      text-align: left;
      color: rgba(140, 140, 140, 1);
    }
  }
</style>
